export function setNoLeadscoringCookie() {
    // This runs as callback when leadscoring offcanvas is being exited
    const leadscoring = document.querySelector('[data-ct-leadscoring-id]');

    if (!leadscoring) {
        return;
    }

    const { ctLeadscoringUrl: url } = leadscoring.dataset;

    // this endpoint is responsible for setting the no leadscoring cookie
    fetch(`${url}/no-form-cookie/`);
}
